import {Navigate, useLocation} from 'react-router-dom';

import {PublicPaths} from './path';
import {isAuthenticated} from '../utils';
import {ChildProps} from '../interface';
import {getStoredUser} from '../storage';

const AuthGuard = ({children}: ChildProps) => {
  const location = useLocation();
  const user = getStoredUser();
  const isAdmin = ['Admin', 'SuperAdmin'].includes(String(user?.role || ''));

  if (isAuthenticated() && isAdmin) {
    return <>{children}</>;
  }
  return <Navigate to={PublicPaths.LOGIN} state={{from: location}} replace />;
};

export default AuthGuard;
